import React from 'react';
import LazyImage from './LazyImage';
import loader from '../../Assets/3-dots-loader.svg'

const Loader = ({height = "h-auto"}) => {
    return (
        <div className={`flex items-center justify-center mb-5 bg-white grayBlurShadow mt-5 rounded-3xl ${height}`}>
            <div className=' h-fit w-fit flex flex-col items-center justify-center mb-5 mt-5 rounded-3xl '>
                <LazyImage classNameImg='m-auto w-16' src={loader} alt="loading..." />
                {/* <span>Loading...</span> */}
            </div>
        </div>
    );
}

export default Loader;

export const SmallLoader = () => {
    return (
        <div className='flex items-center justify-center bg-whiterounded-3xl '>
           <span className={`flex items-center justify-center`}>
                {/* props.loadingCss => custom classes passed for loader size or color */}
                <span
                    className={`animate-spin rounded-full border-8 border-t-transparent border-gray-400`}
                    role="status"
                >
                    <span className="sr-only"></span>
                </span>
            </span> 
        </div>
    );
}
